// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGImage = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#image__clip0_14386_16263)",
    children: [/*#__PURE__*/_jsx("path", {
      fillOpacity: 0.01,
      d: "M0 0h24v24H0z"
    }), /*#__PURE__*/_jsx("mask", {
      id: "image__b",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 24,
      height: 24,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#image__clip1_14386_16263)",
        children: /*#__PURE__*/_jsxs("g", {
          clipPath: "url(#image__clip2_14386_16263)",
          children: [/*#__PURE__*/_jsxs("mask", {
            id: "image__a",
            style: {
              maskType: 'alpha'
            },
            maskUnits: "userSpaceOnUse",
            x: 0,
            y: 3,
            width: 24,
            height: 18,
            children: [/*#__PURE__*/_jsx("path", {
              d: "M15.3 10.877c1.002-1.003 2.631-1.003 3.634 0l1.38 1.38c.335.333.335.874 0 1.208-.334.334-.874.334-1.208 0l-1.38-1.38c-.335-.334-.883-.334-1.208 0L13.79 14.81c-.968.968-2.666.968-3.634 0l-.994-.995c-.325-.325-.891-.325-1.208 0l-3.06 3.06c-.172.172-.387.25-.61.25-.222 0-.436-.087-.608-.25-.334-.334-.334-.874 0-1.208l3.06-3.06c1.003-1.003 2.631-1.003 3.634 0l.995.994c.325.326.891.326 1.208 0l2.726-2.725zM5.622 7.705c.738 0 1.338.6 1.338 1.337s-.6 1.338-1.338 1.338c-.736 0-1.336-.601-1.336-1.338 0-.737.6-1.337 1.336-1.337z"
            }), /*#__PURE__*/_jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M21.429 3.428C22.843 3.428 24 4.585 24 5.999v12c0 1.414-1.157 2.572-2.571 2.572H2.57C1.157 20.57 0 19.413 0 17.999V6c0-1.414 1.157-2.571 2.571-2.571H21.43zM2.57 5.142c-.471 0-.857.386-.857.857v12c0 .472.386.857.857.857H21.43c.471 0 .857-.385.857-.857V6c0-.471-.386-.857-.857-.857H2.57z"
            })]
          }), /*#__PURE__*/_jsx("g", {
            mask: "url(#image__a)",
            children: /*#__PURE__*/_jsx("path", {
              d: "M-1.714-1.715h27.429v27.429H-1.714z"
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#image__b)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h24v24H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "image__clip0_14386_16263",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h24v24H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "image__clip1_14386_16263",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h24v24H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "image__clip2_14386_16263",
      children: /*#__PURE__*/_jsx("path", {
        transform: "translate(-1.714 -1.715)",
        d: "M0 0h27.429v27.429H0z"
      })
    })]
  })]
}));
SVGImage.displayName = 'SVGImage';
export default SVGImage;